module.exports = __webpack_public_path__ + "img/nested-list-app-example.cbb4a1a1.png";